import React from "react";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faPlus } from "@fortawesome/free-solid-svg-icons";

const VarietyAdd = ({ addVariety }) => {
    const handleAdd = () => {
        addVariety("");
    };

    return (
        <div className="variety-add">
            <div className="button-group">
                <h3>Varieties</h3>
                <button className="button -small -primary" onClick={handleAdd} title="Add Variety">
                    <FontAwesomeIcon icon={faPlus} />
                </button>
            </div>

            <h4>Link Variety To:</h4>
        </div>
    );
};

export default VarietyAdd;
